export default "__VITE_ASSET__44167511__"